export var setExpiration = function setExpiration(name, days) {
  var date = new Date();
  var secondsFromNow = 1000 * 60 * 60 * 24 * days;
  var expires = date.setTime(date.getTime() + secondsFromNow);
  window.localStorage.setItem(name, expires);
  return true;
};
export var checkExpiration = function checkExpiration(name, days) {
  var expires = window.localStorage.getItem(name);
  var now = new Date().getTime();

  if (parseInt(expires - now, 10) <= 0) {
    setExpiration(name, days);
    return false;
  }

  return true;
};
export var get = function get(name) {
  return window.localStorage.getItem(name);
};